module.exports = __webpack_public_path__ + "static/media/stormCraft.b8b40be4.jpeg";